<template>
  <div>
    <v-row class="pa-3" justify="end">
      <v-btn
        color=kazan
        outlined
        @click="addNewContact()"
        v-if="isManaged"
      >
        <v-icon>add</v-icon>
        {{$t('buttons.add_new')}}
      </v-btn>
    </v-row>

    <ContactListItem
      :isManaged="isManaged"
      v-for="result in Object.keys(contacts)"
      :contact="contacts[result]"
      :key="result"
      @editContact="editContact"
    />
    <ContactFormDialog
      v-if="isManaged && contactFormDialog"
      v-model="contactFormDialog"
      :companyID="companyID"
      :contactID="editingContactID"
      @fetchNew="$emit('fetchContacts')"
    />
  </div>
</template>

<script>
import router from '@/router'
import ContactListItem from '@/components/contacts/ContactListItem'
import ContactFormDialog from '@/components/contacts/ContactFormDialog'

export default {
  name: 'ContactList',
  components: {
    ContactListItem,
    ContactFormDialog
  },
  props: {
    isManaged: Boolean,
    contacts: Object,
    companyID: String
  },
  data () {
    return {
      contactFormDialog: false,
      editingContactID: null
    }
  },
  methods: {
    gotoContactDetail (contactID) {
      router.push({
        name: 'ContactDetail',
        params: { contactID: contactID }
      })
    },
    addNewContact () {
      this.editingContactID = null
      this.contactFormDialog = true
    },
    editContact (contactID) {
      this.editingContactID = contactID
      this.contactFormDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
